import { datatypes, inputTypes } from "data/globalData";
import { catalogActiveStatusColumn } from "../shared/catalogMasterUi";

export const THREAD_CATALOGS = {
	THREAD_ITEMS: "thread_items",
	THREAD_SHADES: "thread_shades",
};

export const threadCatalogTabs = [
	{ key: THREAD_CATALOGS.THREAD_ITEMS, name: "Thread Items" },
	{ key: THREAD_CATALOGS.THREAD_SHADES, name: "Thread Shades" },
];

const baseColumn = (name, key, inputType = inputTypes.ENTER.key, required = false) => ({
	name,
	key,
	data_type: datatypes.STRING.key,
	input_type: inputType,
	constraints: { NOTNULL: required, DISPLAY: true },
});

export const threadCatalogPrimaryKeys = {
	[THREAD_CATALOGS.THREAD_ITEMS]: "thread_item_code",
	[THREAD_CATALOGS.THREAD_SHADES]: "shade_code",
};

export const threadEditableFields = {
	[THREAD_CATALOGS.THREAD_ITEMS]: ["brand", "article", "tex", "tkt", "meters", "uom", "code", "active_status"],
	[THREAD_CATALOGS.THREAD_SHADES]: ["active_status"],
};

export const threadCreatableFields = {
	[THREAD_CATALOGS.THREAD_ITEMS]: ["brand", "article", "tex", "tkt", "meters", "uom", "code", "active_status"],
	[THREAD_CATALOGS.THREAD_SHADES]: ["shade_code", "active_status"],
};

export const threadAutoPrimaryKeyCatalogs = new Set([THREAD_CATALOGS.THREAD_ITEMS]);

export const threadCatalogColumns = {
	[THREAD_CATALOGS.THREAD_ITEMS]: [
		baseColumn("Code", "thread_item_code"),
		baseColumn("Brand", "brand", inputTypes.ENTER.key, true),
		baseColumn("Article", "article", inputTypes.ENTER.key, true),
		baseColumn("TEX", "tex"),
		baseColumn("TKT", "tkt"),
		baseColumn("Meters", "meters"),
		baseColumn("UOM", "uom"),
		baseColumn("ERP Code", "code", inputTypes.ENTER.key, true),
		catalogActiveStatusColumn,
	],
	[THREAD_CATALOGS.THREAD_SHADES]: [baseColumn("Shade Code", "shade_code", inputTypes.ENTER.key, true), catalogActiveStatusColumn],
};

export const getThreadRowId = (catalog, row) => {
	switch (catalog) {
		case THREAD_CATALOGS.THREAD_ITEMS:
			return row.thread_item_code;
		case THREAD_CATALOGS.THREAD_SHADES:
			return row.shade_code;
		default:
			return row.id;
	}
};
